import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import { actions as modalActions } from '@store/slice/modal-slice';
import { useTypedDispatch } from '@hook/common/useStore';
import { useNavigate } from 'react-router-dom';
import { IProblemScoreModalData } from '@datatype/iyagigo/type';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { MEDIUM_MODAL_WIDTH } from '@constant/size';

interface IProps {
  data: IProblemScoreModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${MEDIUM_MODAL_WIDTH};
`;

const TITLE_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: true },
  box: { margin: `0px 0px ${size.MARGIN_1} 0px` },
} as const;

const SCORE_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BROWN_2, bold: true },
  box: { margin: `0px 0px 5px 0px` },
} as const;

const DESCRIPTION_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: false },
  box: { margin: `0px 0px ${size.MARGIN_2} 0px` },
} as const;

const GO_HOME_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BROWN_1, bold: false, underline: true },
  box: { margin: `${size.MARGIN_1} 0px 0px 0px`, event: { cursor: 'pointer' } },
} as const;

const ProblemScoreModal: React.FC<IProps> = ({ data }) => {
  const { problemType, score, totalScore } = data;

  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleGoHomeClick = () => {
    dispatch(modalActions.hideModal());
    navigate(IYAGIGO_PATH.TEST_HOME_PATH);
  };

  return (
    <Wrapper>
      <TextBlock text={`${problemType === 'toeic' ? 'TOEIC' : 'JLPT'} 학습 완료`} design={TITLE_TEXT_DESIGN} />
      <TextBlock text={`${score} / ${totalScore}`} design={SCORE_TEXT_DESIGN} />
      <TextBlock text={`정답률 ${Math.round((score / totalScore) * 100)}%`} design={DESCRIPTION_TEXT_DESIGN} />
      <TextBlock text={'홈으로 돌아가기'} design={GO_HOME_TEXT_DESIGN} click={{ handler: handleGoHomeClick }} />
    </Wrapper>
  );
};

export default ProblemScoreModal;
